<template>
  <!-- 数据上报页面 -->
  <div class="vl-data-interface">
      <el-tabs v-model="tabName" @tab-click="tabSelect">
        <el-tab-pane label="已申请" name="1">
          <div class="queryCondition">
              <el-select v-model="levelId" clearable placeholder="选择级别" style="width: 120px;margin-right: 10px;">
                  <el-option v-for="item in levelList" :key="item.code" :label="item.name"
                          :value="item.code">
                  </el-option>
              </el-select>
              <!-- <el-select v-model="sceneId" clearable placeholder="选择应用场景" style="width: 150px;margin-right: 10px;">
                  <el-option v-for="item in sceneList" :key="item.code" :label="item.name"
                          :value="item.code">
                  </el-option>
              </el-select> -->
              <el-cascader
                style="margin-right: 10px"
                v-model="sceneId"
                :options="treeList"
                placeholder="选择数据分类"
                clearable
                :props="props"
                ></el-cascader>
              <el-select v-model="status" clearable placeholder="选择状态" style="width: 120px;margin-right: 10px;">
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
              <el-input v-model="keyWord" placeholder="请输入标准名称查询"
                          style="width: 240px;margin-right: 10px;" maxlength="30"></el-input>
              <el-button type="primary" :loading="searchLoading" @click="getInterfaceData">查询</el-button>
          </div>
          <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="levelName" label="级别" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="sceneName" label="数据分类" min-width="150">
              </el-table-column>
              <el-table-column prop="standardName" label="标准名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="standardCode" label="标准编码" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="apiCode" label="API名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="statusName" label="上报状态" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.status == '0'">待审核</span>
                  <span v-if="scope.row.status == '1'">上报中</span>
                  <span v-if="scope.row.status == '2'">已驳回</span>
                  <span v-if="scope.row.status == '3'">已取消</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="200">
                  <template slot-scope="scope">
                      <el-button type="text"   @click="propertyBtn(scope.row.standardCode)">查看属性</el-button>
                      <el-button type="text"   @click="dataBtn(scope.row.standardCode,scope.row.standardName)">查看数据</el-button>
                      <el-button type="text"  v-if="scope.row.status != 3" @click="deleteBtn(scope.row.standardCode)">取消上报</el-button>
                      <el-button type="text"  v-if="scope.row.status == 3" @click="applyBtn(scope.row.standardCode)">申请上报</el-button>
                  </template>
              </el-table-column>
              </el-table>
          <el-pagination v-if="pagination.totalNum > 0" background layout="prev, pager, next" :current-page.sync="pagination.pageNo"
                      :total="pagination.totalNum" @current-change="handleCurrentChange"
                      :page-size.sync="pagination.pageSize">
          </el-pagination>
        </el-tab-pane>
        
        <!-- 未申请标签页面 -->
        <el-tab-pane label="未申请" name="2">
            <div class="queryCondition">
              <div class="search-main">
              <el-select v-model="levelId" clearable placeholder="选择级别" style="width: 120px;margin-right: 10px;">
                  <el-option v-for="item in levelList" :key="item.code" :label="item.name"
                          :value="item.code">
                  </el-option>
              </el-select>
              <!-- <el-select v-model="sceneId" clearable placeholder="选择应用场景" style="width: 150px;margin-right: 10px;">
                  <el-option v-for="item in sceneList" :key="item.code" :label="item.name"
                          :value="item.code">
                  </el-option>
              </el-select> -->
              <el-cascader
                v-model="sceneId"
                :options="treeList"
                placeholder="选择数据分类"
                :props="props"
                clearable
                style="margin-right: 10px;"
                ></el-cascader>
              <el-input v-model="keyWord" placeholder="请输入标准名称查询"
                          style="width: 240px;margin-right: 10px;" maxlength="30"></el-input>
              <el-button type="primary" @click="getInterfaceData">查询</el-button>
              </div>
              <div class="search-right">
                <el-button  class="applyBtn" @click="subInterface">提交申请</el-button>
              </div>
              
              
            </div>
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
                 <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column prop="levelName" label="级别" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="sceneName" label="数据分类" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="standardName" label="标准名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="standardCode" label="标准编码" show-overflow-tooltip>
                </el-table-column>
            </el-table>
        </el-tab-pane>

        <el-tab-pane label="上报数据记录" name="3">
          <filter-table :get-api="pageDataRecord" :filter-items="dataFilterItems" :ext-params="{ appId: $route.query.appId }">
            <el-table-column label="标准名称" prop="standardName" show-overflow-tooltip></el-table-column>
            <el-table-column label="标准编码" prop="standardCode" show-overflow-tooltip></el-table-column>
            <el-table-column label="校验状态" prop="verifyState" show-overflow-tooltip>
              <template v-slot="scope">{{ scope.row.verifyState == "1" ? "校验成功" : "校验失败" }}</template>
            </el-table-column>
            <el-table-column label="校验信息" prop="verifyMessage" show-overflow-tooltip></el-table-column>
            <el-table-column label="上传时间" prop="dateTime" width="160"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button type="text" size="small" @click="checkData(scope.row)">查看数据详情</el-button>
              </template>
            </el-table-column>
          </filter-table>
        </el-tab-pane>
      </el-tabs>

    <!-- 查看标准属性弹窗 -->
    <el-dialog
      title="查看标准属性"
      :visible.sync="propertyDialog"
      append-to-body
      :close-on-click-modal="false"
      width="800px"
      z-index="1000"
    >
      <div class="propertyTableDialog" style="height: auto;">
      <el-table
        :class="propertyTable.length == 0 ? 'emptyTable' : ''"
        :data="propertyTable"
        style="width: 100%"
      >
        <el-table-column
        prop="propertyName"
        label="字段名"
        :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
        prop="propertyCode"
        label="字段编码"
        :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
        prop="propertyType"
        label="字段类型"
        :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
        prop="length"
        label="字段长度"
        :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
        prop="extend"
        label="扩展类型"
        :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
        label="非空"
        width="130px"
        :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row, index }">
                  <span v-if="row.empty == '0'">否</span>
                  <span v-if="row.empty == '1'">是</span>
                </template>
        </el-table-column>
        <el-table-column
        prop="annotation"
        label="注释"
        width="130px"
        :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <g-empty v-if="!propertyTable.length" />
      </div>
    </el-dialog>




    <el-drawer
      :title="dataDrawerTitle"
      :visible.sync="dataDrawer"
      direction="rtl"
      :show-close="false"
      size="88%"
      :wrapperClosable="false"
      @close="dataDrawerClose"
    >
    <div class = "iconClose" @click = "dataDrawerClose"><i class = "iconC"></i></div>
    <!-- <div class = "iconClose" @click = "dataDrawer = false"><i class = "el-icon-close iconC"></i></div> -->
      <div class = "dataDrawerDiv">
        <div class="timeSearchDiv">
          <el-date-picker
            v-model="timeSearch"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="dataSearch()">查询</el-button>
        </div>
        <!-- <el-scrollbar style="height: 500px;"> -->
          <div class="dataContent">
            <el-table :data="dataTable"
              :class="dataTable.length == 0 ? 'emptyTable' : ''">
            <el-table-column prop="standardName" width="150" label="标准名称" :show-overflow-tooltip="true"  >
            </el-table-column>
            <el-table-column prop="standardCode" width="150" label="标准编码" align="left" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="dateTime" width="200" label="上传时间" align="left" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="dateJson" label="标准数据" align="left" :show-overflow-tooltip="true" >
            </el-table-column>
            </el-table>
          </div>
        <!-- </el-scrollbar> -->
        <el-pagination v-if="dataPage.totalNum > 0" background layout="prev, pager, next" :current-page.sync="dataPage.pageNo"
                          :total="dataPage.totalNum" @current-change="dataPageChange"
                          :page-size.sync="dataPage.pageSize">
              </el-pagination>
      </div>
    </el-drawer>


    <el-dialog title="查看数据详情" :visible.sync="checkDataOpen" append-to-body width="800px">
      <el-form class="data-detail" label-width="85px">
        <el-form-item label="标准名称：">{{ checkDataRow.standardName }}</el-form-item>
        <el-form-item label="标准编码：">{{ checkDataRow.standardCode }}</el-form-item>
        <el-form-item label="校验状态：">
          <span :style="{ color: checkDataRow.verifyState === '1' ? 'green' : 'red' }">
            {{ checkDataRow.verifyState === "1" ? "校验成功" : "校验失败" }}
          </span>
        </el-form-item>
        <el-form-item label="校验信息：">
          <span :style="{ color: checkDataRow.verifyState === '1' ? 'green' : 'red' }">
            {{ checkDataRow.verifyMessage }}
          </span>
        </el-form-item>
        <el-form-item label="上传时间：">{{ checkDataRow.dateTime }}</el-form-item>
        <el-form-item label="数据详情：">
          <div class="detail-item" v-for="(value, key) in JSON.parse(checkDataRow.dateJson || '{}')" :key="key">
            {{ key }}： {{ value }}
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  import {
    PersonalDataGetDateLevel,
    PersonalDataGetDateSceneByAppId,
    PersonalDataPageListDateStandardInfo,
    PersonalDataGetDataPropertyByCode,
    PersonalDataPageListDataByCondition,
    PersonalDataDeleteDataStandard,
    PersonalDataApplyDataStandard,
    PersonalDataGetTree,
    getListStandardDefine,
  } from '@/views/index/api/personalCenter/api.personalCenter.js';
  import FilterTable from "./FilterTable.vue";
  import DataRangePicker from "./DateRangePicker.vue";
  import { formatDateTime } from "@/utils/util";

  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const endDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const dateRangeTime = [formatDateTime(firstDay), formatDateTime(endDay)];

  const statusOptions = [{ label: '校验成功', value: '1' }, { label: '校验失败', value: '0' }];

  export default {
    components: { FilterTable, DataRangePicker },
    data() {
      return {
        //应用id
        appId:"",
        //列表属性
        tabName:"1",//Tab名称
        loadingShow: true,
        searchLoading: false,
        levelId: "",//等级id
        sceneId: [],//场景id
        status: "",//状态id
        keyWord: "",//关键字
        dateTypeId:"",
        viewBtn: true,
        //登记列表(code、name)
        levelList: [],
        //应用场景(code、name)
        sceneList: [],
        //标准数据树
        treeList:[],
        props:{
          label:"dirName",
          value:"dirId",
          checkStrictly: true,
        },
        //状态列表
        statusList: [{
          value: '0',
          label: '待审核'
        }, {
          value: '1',
          label: '上报中'
        }, {
          value: '3',
          label: '已取消'
        }],
        multipleSelection: [],//提交页面的接口选择
        tableData: [],//标准table数据
        pagination: {//分页
          pageNo: 1,
          pageSize: 10,
          totalNum: 0
        },
        // 上报数据记录
        standardList: [],
        pageDataRecord: PersonalDataPageListDataByCondition,
        checkDataOpen: false,
        checkDataRow: {},

        //查看属性弹窗的属性值
        propertyDialog:false,//属性弹窗
        propertyTable: [],//属性值列表

        //查看数据滑层的属性值
        standardCode:"",
        standardName:"",
        dataDrawerTitle: "查看数据",
        dataTableLoading:true,
        dataDrawer:false,
        dataTable: [],
        dataPage:{
          pageNo:1,
          pageSize:10,
          totalNum:0,
        },
        timeSearch:'',
      }
    },
    computed: {
      dataFilterItems() {
        return [
          { name: "standardCode", type: "select", options: this.standardList, placeholder: "选择标准名称", width: 140 },
          { name: "verifyState", type: "select", options: statusOptions, placeholder: "校验状态" },
          { name: ["startDate", "endDate"], type: "custom", component: DataRangePicker, defaultValue: dateRangeTime },
          { name: "dataContent", type: "input", placeholder: "输入数据详情关键字" },
        ];
      },
    },
    mounted() {
      this.appId = this.$route.query.appId;
      this.getDateLevelList();//获取等级下拉
      // this.getDateSceneList();//获取场景下拉
      this.getDateTree();//获取标准数据树下拉
      this.getInterfaceData(); //获取默认数据
      this.getStandardList(); // 获取标准数据下拉
    },
    methods: {
      //获取等级列表
      getDateLevelList() {
        PersonalDataGetDateLevel().then(res => {
          if (res && res.code == "00000") {
            this.levelList = res.result;
          }
        })
      },
      // 获取标准数据树
      getDateTree(){
        PersonalDataGetTree({showData:false,parentId:1}).then(res=>{
          if (res && res.code == "00000") {
            if(res.result&&res.result.length>0){
              this.treeList = res.result;
              this.deleteEmptyChildren(this.treeList);
            }
          }
        })
      },
      // 删除空的children
      deleteEmptyChildren(res){
        res.forEach(el=>{
          if(el.children&&el.children.length>0){
            this.deleteEmptyChildren(el.children)
          }else{
            el.children=null;
          }
        })
      },
      //根据应用id获取场景列表
      getDateSceneList() {
        PersonalDataGetDateSceneByAppId({ appId: this.appId }).then(res => {
          if (res && res.code == "00000") {
            this.sceneList = res.result;
          }
        })
      },
      //切换tab页面的时候初始化下拉数据并获取数据
      tabSelect() {
        if (this.tabName === "1" || this.tabName === "2") {
          this.levelId="";
          this.sceneId=[];
          this.status="";
          this.keyWord="";
          this.tableData= [];
          this.pagination.pageNo = 1;
          this.pagination.pageSize = 10;
          this.pagination.totalNum = 0;
          this.getInterfaceData();
        }
      },
      //搜索数据标准列表
      getInterfaceData() {
        let params = {
          appId: this.appId,
          levelId: this.levelId,
          sceneId: this.sceneId[this.sceneId.length-1],
          status: this.status,
          searchKey: this.keyWord,
          tabNum: this.tabName,
          pageNo: 1,
          pageSize: 10
        }
        PersonalDataPageListDateStandardInfo(params).then(res => {
          if (res && res.code == "00000") {
            this.tableData = res.result.list;
            this.pagination.pageNo = res.result.pageNo;
            this.pagination.pageSize = res.result.pageSize;
            this.pagination.totalNum = res.result.totalNum;
          }
        })
      },
      // 表格中数据标准选择信息
      handleSelectionChange(val) {
        this.multipleSelection = val.map((item) => item.standardCode);
      },
      //未订阅页面的批量提交接口订阅
      subInterface(){
        if (this.multipleSelection.length == 0) {
          this.$message.warning("请先选择接口")
          return
        }
        let params = {
          appId: this.appId,
          standardCodeList:this.multipleSelection
        }
        PersonalDataApplyDataStandard(params).then(res => {
          if (res && res.code == "00000") {
            this.$MyMessage("申请成功", 'success');
            this.getInterfaceData();
          }
        })
      },
      //搜索控件切换页码时候的处理(这个页面没有切换每页条数，不用考虑超出范围的情况)
      handleCurrentChange() {
        let params = {
          appId: this.appId,
          levelId: this.levelId,
          sceneId: this.sceneId[this.sceneId.length-1],
          status: this.status,
          searchKey: this.keyWord,
          tabNum: this.tabName,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize
        }
        PersonalDataPageListDateStandardInfo(params).then(res => {
          if (res && res.code == "00000") {
            this.tableData = res.result.list;
            this.pagination.pageNo = res.result.pageNo;
            this.pagination.pageSize = res.result.pageSize;
            this.pagination.totalNum = res.result.totalNum;
          }
        })
      },
      //点击查看属性按钮
      propertyBtn(val) {
        PersonalDataGetDataPropertyByCode({ standardCode: val }).then(res => {
          if (res && res.code == "00000") {
            this.propertyTable = res.result;
            this.propertyDialog = true;
          }
        })
      },
      //查看数据按钮
      dataBtn(val,name) {
        this.standardCode = val;
        this.standardName = name;
        this.dataTable=[];
        let params = {
          appId: this.appId,
          standardCode:val,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize
        }
        let that = this;
        PersonalDataPageListDataByCondition(params).then(res => {
          if (res && res.code == "00000") {
            res.result.list.forEach(function (data) {
                let standardDate = {
                standardName:name,
                standardCode:data.standardCode,
                dateTime:data.dateTime,
                dateJson:data.dateJson,
              }
              that.dataTable.push(standardDate);
            });
            that.dataPage.pageNo = res.result.pageNo;
            that.dataPage.pageSize = res.result.pageSize;
            that.dataPage.totalNum = res.result.totalNum;
            that.dataDrawer = true;
          }
        })
      },
      deleteBtn(val) {
        let params = {
          appId: this.appId,
          standardCode:val,
        }
        PersonalDataDeleteDataStandard(params).then(res => {
          if (res && res.code == "00000") {
            this.getInterfaceData();
            this.$MyMessage("取消成功", 'success');
          }
        })
      },
      applyBtn(val) {
        let standardCodeList = [];
        standardCodeList.push(val);
        let params = {
          appId: this.appId,
          standardCodeList:standardCodeList,
        }
        PersonalDataApplyDataStandard(params).then(res => {
          if (res && res.code == "00000") {
            this.getInterfaceData();
            this.$MyMessage("申请成功", 'success');
          }
        })
      },
      //查看数据页面点击查看按钮
      dataSearch() {
        this.dataTable=[];
        let startDate = "";
        let endDate = "";
        if(this.timeSearch) {
          startDate = this.timeSearch[0];
          endDate = this.timeSearch[1];
        }
        let params = {
          appId: this.appId,
          standardCode:this.standardCode,
          startDate:startDate,
          endDate:endDate,
          pageNo: 1,
          pageSize: 10
        }
        let that = this;
        PersonalDataPageListDataByCondition(params).then(res => {
          if (res && res.code == "00000") {
            res.result.list.forEach(function (data) {
                let standardDate = {
                standardName:that.standardName,
                standardCode:data.standardCode,
                dateTime:data.dateTime,
                dateJson:data.dateJson,
              }
              that.dataTable.push(standardDate);
            });
            that.dataPage.pageNo = res.result.pageNo;
            that.dataPage.pageSize = res.result.pageSize;
            that.dataPage.totalNum = res.result.totalNum;
          }
        })
      },
      //关闭查看数据滑层
      dataDrawerClose() {
        this.dataDrawer = false;
        this.standardCode = "";
        this.standardName = "";
        this.dataTable = [];
        this.dataPage.pageNo = 1;
        this.dataPage.pageSize = 10;
        this.dataPage.totalNum = 0;
        this.timeSearch="";
      },

      //查看数据分页控件切换
      dataPageChange() {
        console.log(this.pagination);
        this.dataTable=[];
        let startDate = "";
        let endDate = "";
        if(this.timeSearch) {
          startDate = this.timeSearch[0];
          endDate = this.timeSearch[1];
        }
        let params = {
          appId: this.appId,
          standardCode:this.standardCode,
          startDate:startDate,
          endDate:endDate,
          pageNo: this.dataPage.pageNo,
          pageSize: this.dataPage.pageSize
        }
        console.log(params);
        let that = this;
        PersonalDataPageListDataByCondition(params).then(res => {
          if (res && res.code == "00000") {
            res.result.list.forEach(function (data) {
                let standardDate = {
                standardName:that.standardName,
                standardCode:data.standardCode,
                dateTime:data.dateTime,
                dateJson:data.dateJson,
              }
              that.dataTable.push(standardDate);
            });
            that.dataPage.pageNo = res.result.pageNo;
            that.dataPage.pageSize = res.result.pageSize;
            that.dataPage.totalNum = res.result.totalNum;
          }
        })
      },

      // 标准数据列表
      getStandardList() {
        getListStandardDefine(this.appId).then(res => {
          if (res && res.code == "00000") {
            this.standardList = res.result.map(item => ({ label: item.standardName, value: item.standardCode }));
          }
        })
      },
      //数据记录查看详情
      checkData(row) {
        this.checkDataRow = row;
        this.checkDataOpen = true;
      },
    }
  }
</script>
<style lang="scss">
  .vl-data-interface {
    width: 100%;
    .el-pagination {
      text-align: center;
      margin: 30px 0 50px;
    }
    .queryCondition {
      display: flex;
      justify-content: left;
      align-items: center;
      margin-bottom: 20px;
    }
    .queryCondition .el-button {
      padding: 10px 24px !important;
    }
    .queryCondition .el-button--default {
      border: 1px solid #4286F5 !important;
      color: #4286F5 !important;
    }
    .queryCondition .search-main {
      flex: 1;
    }
    .has-gutter tr th{
      background-color: #F1F8FF !important;
      border-bottom: none !important;
    }
  }
  
  .propertyTableDialog tr th{
    background-color: #F1F8FF !important;
    border-bottom: none !important;
  }
  .timeSearchDiv {
    margin-bottom: 20px;
    .el-button {
      margin-left: 20px;
    }
  }
  .dataDrawerDiv {
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }
  .el-drawer__header {
    background: #F7F7FA;
    padding: 20px 0 20px 20px;
    margin-bottom: 0;
    span {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      &:focus {
        outline: none;
      }
    }
  }
.el-drawer{
overflow: inherit !important;
}


.iconClose{
  width: 50px;
  height: 50px;
  position: absolute;
  left: -48px;
  top: 0;
  background-color: #fff;
  border-radius: 4px;
  z-index: 999;
  .iconC{
    display:inline-block;
    font-size:50px;
    width: 20px;
    height: 20px;
    position: absolute;
    z-index: 1000;
    position: absolute;
    color:#909399;
  }
}


.el-table-column {
  .el-button {
    font-size: 14px;
  }
}



.iconClose{
  width: 50px;
  height: 50px;
  position: absolute;
  left: -48px;
  top: 0;
  background-color: #fff;
  border-radius: 4px;
  z-index: 999;
  &:hover {
    background-color: #EAF1F8;
    .iconC {
      animation:turn 0.5s linear forwards;
      cursor: pointer;
      background: url("../../../../../assets/img/close-active.png") no-repeat center center;
    }
  }
  .iconC{
    display:inline-block;
    width: 20px;
    height: 20px;
    position: absolute;
    z-index: 1000;
    position: absolute;
    left: 50%;
    margin-left: -10px;
    top: 50%;
    margin-top: -10px;
    background: url("../../../../../assets/img/close.png") no-repeat center center;
    @keyframes turn{
      0%{-webkit-transform:rotate(0deg);}

      100%{-webkit-transform:rotate(180deg);}

    }
  }
}

.el-range-separator{
  width: 20px !important;
}

.data-detail .el-form-item {
  margin-bottom: 0!important;
}

.detail-item {
  padding-top: 12px;
  line-height: 1;
  &:last-child {
    margin-bottom: 20px;
  }
}
</style>